(() => {
  if (customElements.get('dropdown-disclosure')) {
    return;
  }

  class DropdownDisclosure extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.shouldCloseOnBlur =
        this.getAttribute('data-should-close-on-blur') !== 'false';
      this.detailsElement = this.querySelector('details');
      this.summaryElement = this.querySelector('summary');
      this.content = this.summaryElement.nextElementSibling;

      this.init();

      if (this.shouldCloseOnBlur) {
        document.addEventListener('click', this.shouldClose.bind(this));
      }
    }

    init() {
      this.querySelector('summary').addEventListener(
        'click',
        this.onSummaryClick.bind(this),
      );
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');

      isOpen
        ? this.close(event, summaryElement, detailsElement)
        : this.open(summaryElement, detailsElement);
    }

    open(summaryElement, detailsElement) {
      setTimeout(() => {
        detailsElement.classList.add('is-open');

        const productSelector = this.querySelector('product-selector');

        if (productSelector && this.classList.contains('card-upsell')) {
          productSelector.initCarouselAnimation();
        }
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(detailsElement, summaryElement);

      if (this.classList.contains('card-upsell')) {
        const currentItem = this.closest('[data-widget-item]');
        const widgetOverflow = this.closest('[data-widget-overflow]');

        if (!widgetOverflow) {
          return;
        }

        setTimeout(() => {
          widgetOverflow.scrollTo({
            top: currentItem.offsetTop,
            behavior: 'smooth',
          });
        }, 500);
      }
    }

    close(event, summaryElement, detailsElement) {
      if (event === undefined) return;
      event.preventDefault();

      detailsElement.classList.remove('is-open');
      removeTrapFocus(summaryElement);
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        elapsedTime < 400
          ? window.requestAnimationFrame(handleAnimation)
          : detailsElement.removeAttribute('open');
      };

      window.requestAnimationFrame(handleAnimation);
    }

    /**
     * Should close
     * @param {Event} event Click event
     * @param {Boolean} force Force close, event can be null
     * @returns Void
     */
    shouldClose(event, force) {
      const isOpen = this.detailsElement.hasAttribute('open');

      if (force && isOpen) return this.summaryElement.click();

      const isClickOriginFromSummary =
        event.target === this.summaryElement ||
        this.summaryElement.contains(event.target);
      const isClickOriginFromContent =
        this.content.contains(event.target) || event.target === this.content;
      const shouldClose =
        !isClickOriginFromContent && !isClickOriginFromSummary;

      if (!shouldClose) return;

      if (isOpen) {
        this.detailsElement.classList.remove('is-open');
        this.closeAnimation(this.detailsElement);
      }
    }
  }

  customElements.define('dropdown-disclosure', DropdownDisclosure);
})();
